import { render, staticRenderFns } from "./MonthlyIssue.vue?vue&type=template&id=b08fd34e"
import script from "./MonthlyIssue.vue?vue&type=script&lang=js"
export * from "./MonthlyIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports